<template lang="pug">
  Wrapper.q-px-lg.q-py-xl
    h5.q-mb-xl Admin Roles
    .container-fluid.bg-gray.q-mb-md
      .row.items-center
        .col-12
          md-button.md-primary
            .flex.items-center
              md-icon.md-primary.q-mr-xs cached
              span Reset
          md-button.md-primary.items-center(@click='addAdminRoleModal.isOpen = true')
            .flex.items-center
              md-icon.md-primary.q-mr-xs add
              span Add
    DataTable(:columns='columns')
      md-table-row(v-for='(item, idx) in list', :key='idx')
        md-table-cell(md-numeric) {{ item.no }}
        md-table-cell {{ item.role }}
        md-table-cell {{ item.createTime | formatDateTime }}
        md-table-cell
          span.text-action.q-mr-md(@click='openEntitlementModal') Entitlement
    md-dialog-prompt(
      :md-active.sync='addAdminRoleModal.isOpen'
      md-title='Add Admin Role'
      md-confirm-text='Save'
      md-input-placeholder='Enter new admin role'
      v-model='addAdminRoleModal.role'
      @md-confirm='addAdminRole'
      @md-cancel='closeAddAdminRoleModal')
    Modal.entitlement-modal(
      modalTitle='Admin User Entitlement'
      :showModal='entitlementModal.isOpen'
      :handleCloseModal='closeEntitlementModal')
      .q-mb-md
        .q-mb-md
          span.text-muted.q-mr-md Admin Role:
          span.text-weight-bold Manager
        .q-mb-md
          p.text-muted Role:
          .bg-gray.flex.items-center.q-px-md.wrap
            md-checkbox(v-model="entitlementModal.role" value="1") Orders
            md-checkbox(v-model="entitlementModal.role" value="2") Invoices
            md-checkbox(v-model="entitlementModal.role" value="3") Payments
            md-checkbox(v-model="entitlementModal.role" value="4") Statistics
            md-checkbox(v-model="entitlementModal.role" value="5") Booking History
        .q-mb-md
          p.text-muted User management:
          .bg-gray.flex.items-center.q-px-md.wrap
            md-checkbox(v-model="entitlementModal.userManagement" value="1") Shipper Management
            md-checkbox(v-model="entitlementModal.userManagement" value="2") Transporter Management
        .q-mb-md
          p.text-muted Business management:
          .bg-gray.flex.items-center.q-px-md.wrap
            md-checkbox(v-model="entitlementModal.businessManagement" value="2") Orders
            md-checkbox(v-model="entitlementModal.businessManagement" value="3") Operation City & Price Set
            md-checkbox(v-model="entitlementModal.businessManagement" value="4") Booking Options
        .q-mb-md
          p.text-muted System management:
          .bg-gray.flex.items-center.q-px-md.wrap
            md-checkbox(v-model="entitlementModal.systemManagement" value="1") Admin Users
            md-checkbox(v-model="entitlementModal.systemManagement" value="2") Admin Roles
            md-checkbox(v-model="entitlementModal.systemManagement" value="3") FAQ
            md-checkbox(v-model="entitlementModal.systemManagement" value="4") Login Logs
      template(v-slot:dialog-actions)
        md-button.md-raised.md-primary(@click='') Save
</template>

<script>
import Wrapper from '@/components/Wrapper.vue';
import DataTable from '@/components/DataTable.vue';
import Modal from '@/components/Modal.vue';
import formatDateMixin from '@/utils/mixins/formatDateMixin';

const fake = {
  role: 'Super Administrator',
  createTime: Date.now(),
};

const entitlementModalDefaultState = {
  isOpen: false,
  role: '',
  userManagement: [],
  businessManagement: [],
  systemManagement: [],
};

export default {
  components: { Wrapper, DataTable, Modal },

  mixins: [formatDateMixin],

  data() {
    return {
      list: [],
      addAdminRoleModal: {
        isOpen: false,
        role: '',
      },
      entitlementModal: { ...entitlementModalDefaultState },
    };
  },

  computed: {
    columns() {
      return [
        {
          name: 'no',
          isNumeric: true,
        },
        'role',
        'create time',
        'operation',
      ];
    },
  },

  mounted() {
    for (let i = 0; i < 10; i += 1) {
      this.list.push({
        no: i + 1,
        ...fake,
      });
    }
  },

  methods: {
    closeAddAdminRoleModal() {
      this.addAdminRoleModal.isOpen = false;
      this.addAdminRoleModal.role = '';
    },
    addAdminRole() {
      /* TODO: Implementation */
      this.closeAddAdminRoleModal();
    },
    openEntitlementModal() {
      this.entitlementModal.isOpen = true;
    },
    closeEntitlementModal() {
      this.entitlementModal = { ...entitlementModalDefaultState };
    },
    saveEntitlement() {
      /* TODO: Implementation */
    },
  },
};
</script>

<style lang="scss" scoped>
.entitlement-modal {
  @media screen and (min-width: 48em) {
    width: 75vw;
  }
}
</style>
